import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/generator.svg'

const Generator: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 42 25'} component={Icon} {...props} fill="transparent" />
export default Generator
